import { inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { CanActivateFn } from '@angular/router';
import { AuthenticationService } from '../service/authentication.service';
import { TranslateService } from '@ngx-translate/core';
import {lightGuard} from "./light.guard";
import {isLightRoute} from "@adlatus-gui/shared";

export const CLEARING_SUPER_ADMINISTRATOR = 'CLEARING_SUPER_ADMINISTRATOR';

export const superAdminGuard: CanActivateFn = async (route, state) => {
  if (isLightRoute()) return false;

  const authenticationService = inject(AuthenticationService);
  const messageService = inject(MessageService);
  const translateService = inject(TranslateService);

  const userRoles = authenticationService.getUserRoles();
  const isSuperAdmin = userRoles.includes(CLEARING_SUPER_ADMINISTRATOR);

  if (!isSuperAdmin)
    messageService.add({
      severity: 'error',
      sticky: true,
      summary: translateService.instant('forbidden.summary'),
      detail: translateService.instant('forbidden.detail')
    });

  return isSuperAdmin;
};
